var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
var LanguageService = /** @class */ (function (_super) {
    __extends(LanguageService, _super);
    function LanguageService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.baseUrl = '/v1/language';
        _this._subject = new Subject();
        return _this;
    }
    LanguageService.prototype.put = function (lang) {
        this._subject.next(lang);
    };
    LanguageService.prototype.get = function () {
        return this._subject.asObservable();
    };
    LanguageService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LanguageService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return LanguageService;
}(ContentBaseService));
export { LanguageService };
var Lang = /** @class */ (function () {
    function Lang() {
    }
    return Lang;
}());
export { Lang };
//# sourceMappingURL=language.service.js.map